import { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import MemberForm from './MemberForm';
import MemberTable from './MemberTable';
import { API_BASE_URL } from '../utils';

const AdminDashboard = ({ onLogout }) => {
  const [members, setMembers] = useState([]);
  const [editingMember, setEditingMember] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/members`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMembers(res.data);
    } catch (err) {
      toast.error('Failed to load members');
    }
  };

  const addOrUpdateMember = async (data) => {
    try {
      const token = localStorage.getItem('token');
      if (editingMember) {
        await axios.put(`${API_BASE_URL}/members/${editingMember.id}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success('Member updated');
      } else {
        await axios.post(`${API_BASE_URL}/members`, data, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success('Member added');
      }
      setEditingMember(null);
      fetchMembers();
    } catch (err) {
      toast.error('Operation failed');
    }
  };

  const deleteMember = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_BASE_URL}/members/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Member deleted');
      fetchMembers();
    } catch (err) {
      toast.error('Delete failed');
    }
  };

  const filteredMembers = members.filter((m) =>
    m.name.toLowerCase().includes(search.toLowerCase()) ||
    new Date(m.expiry_date).toLocaleDateString().includes(search)
  );

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-3xl font-bold">Admin Dashboard</h2>
        <button onClick={onLogout} className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">Logout</button>
      </div>
      <MemberForm onSubmit={addOrUpdateMember} editingMember={editingMember} />
      <input
        type="text"
        placeholder="Search by name or expiry date"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="border p-2 mb-4 w-full"
      />
      <MemberTable
        members={filteredMembers}
        onEdit={(member) => setEditingMember(member)}
        onDelete={deleteMember}
      />
    </div>
  );
};

export default AdminDashboard;